import React from 'react';
import {Stack, Typography} from '@mui/material';
import ReportRow from './ReportRow';

/**
 * Displays a table of reports with headers and rows
 * @param {Object} props
 * @param {Array} props.reports - Array of report data
 * @param {Array} props.columns - Column configuration
 * @param {boolean} props.loading - Loading state
 * @returns {JSX.Element}
 */
const ReportsTable = ({reports, columns, loading}) => {
    const renderContent = () => {
        if (loading) {
            return (
                <Stack bgcolor="white" px={2} py={2}>
                    <Typography>Loading reports...</Typography>
                </Stack>
            );
        }

        if (!reports || reports.length === 0) {
            return (
                <Stack bgcolor="white" px={2} py={2}>
                    <Typography>No reports found.</Typography>
                </Stack>
            );
        }

        return reports.map((report, index) => (
            <ReportRow
                key={report.id || index}
                report={report}
                columns={columns}
            />
        ));
    };

    return (
        <Stack
            borderRadius={1}
            border="1px solid #e0e0e0"
            bgcolor="#e0e0e0"
            spacing="1px"
            overflow={'hidden'}
        >
            {/* Table Header */}
            <Stack
                direction="row"
                spacing={2}
                px={2}
                py={1}
                bgcolor="#e9ecef"
                overflow="hidden"
            >
                {columns.map((column) => (
                    <Typography key={column.field} flex={column.flex} fontWeight="bold">
                        {column.headerName}
                    </Typography>
                ))}
            </Stack>

            {/* Table Body */}
            {renderContent()}
        </Stack>
    );
};

export default ReportsTable;
